import { render, staticRenderFns } from "./YesNoQuestions.vue?vue&type=template&id=034bcc49"
import script from "./YesNoQuestions.vue?vue&type=script&lang=ts"
export * from "./YesNoQuestions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports